<template>
  <button 
          type="button" 
          :id="inputButton.id" 
          :class="buttonClass()"
          @click="$emit('changeButton', inputButton.value)"><i class="fas fa-check color-red"></i><span>{{ inputButton.label }}</span></button>
</template>


<script>

export default {
  name: 'custom-button-input',
  props: {
    buttonSelected: 0,
    inputButton: {
        type: Object,
        default: function () {
          return {
            id: 'buttonDefault',
            class: 'button-input-default',
            name: 'buttonDefault',
            label: 'Button',
            style: 'button',
            value: ''
          }
        }
      }
  },
  methods: {
    buttonClass: function() {
        var result = [];
        result.push('btn-check');
        result.push(this.inputButton.class);
        if(this.buttonSelected)
          result.push('btn-check-selected');
       
        return result;
    }
  },
  computed: {
    isFormDirty() {
      return Object.keys(this.fields).some(key => this.fields[key].dirty);
    }
  }
}
</script>

<style scoped>
.btn-check{
  position: relative;
  width: 24px;
  height: 24px;
  
  background-color: #42BD54;
  border-radius: 3px;
  line-height: 1;
  padding: 2px;
  font-weight: 400;
  font-size: 20px;
  text-transform: uppercase;
}

.btn-check:after{
  display: none;
  position: absolute;
  content: "";
  width: 21px;
    height: 21px;
    top: 2px;
    left: 1px;
  background-color: #42BD54;
  background-image: url('../assets/images/white-tick.jpg');
  background-size: cover;
}
.btn-check svg{
  color: #7FCB09;
  /*background: #DD1617;*/
}

.btn-check:hover{
  
  cursor: pointer;
}

.btn.btn-selected{
  background: #515151;
  color: #FFF;
}

.btn-check.btn-check-selected:after{
  display: block;
}


.btn-check span{
  
}

</style>

